// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`InputTooltip test Match con el snapshot 1`] = `
<div class="container input-tooltip-container">
    <!---->
    <div class="input-tooltip-container__inner-component"></div>
    <!---->
</div>
`;
